import { API } from "@/lib/api";
import { APIService } from "@/services/api";
import {
  ReadShiftReportDepartment,
  WriteShiftReportDepartment,
} from "@/types/shiftReportDepartment";

export const ShiftReportDepartmentsService = new APIService<
  ReadShiftReportDepartment,
  WriteShiftReportDepartment
>(API.ShiftReportDepartments);
